import React, { useEffect } from "react";
import ZKcandyLogo from '../assets/images/about-zkcandy-logo.webp';
import AboutTopLeft from '../assets/images/about-top-left.webp';
import AboutTopRight from '../assets/images/about-top-right.webp';
import AboutArtLeft from '../assets/images/about-art-left.webp';
import AboutArtRight from '../assets/images/about-art-right.webp';
import AboutArtLeftMobile from '../assets/images/about-art-left-mobile.webp';
import AboutArtRightMobile from '../assets/images/about-art-right-mobile.webp';
import supportbyWemix from '../assets/images/support-wemix.webp';
import supportbyAnimoca from '../assets/images/support-animoca.webp';
import supportbySpartan from '../assets/images/support-spartan.webp';
import supportbyPerlone from '../assets/images/support-perlone.webp';
import supportbyPresto from '../assets/images/support-presto.webp';
import supportbyFlowdesk from '../assets/images/support-flowdesk.webp';
import supportbyLecca from '../assets/images/support-lecca.webp';
import supportbyEfficientFrontier from '../assets/images/support-efficientfrontier.webp';
import supportbyPrometheuz from '../assets/images/support-prometheuz.webp';
import logoIcandy from '../assets/images/logo-icandy.webp';
import logoZksync from '../assets/images/logo-zksync.webp';
import AboutPlanet from '../assets/images/about-planet.webp';
import AboutPlanetLeft from '../assets/images/about-planet-left.webp';
import AboutPlanetRight from '../assets/images/about-planet-right.webp';
import AboutVR from '../assets/images/about-vr.webp';
import AboutCloud from '../assets/images/about-cloud.webp';


export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  })

  return (
    <div id="about" className="about overflow-hidden">
      <div className="about-bg">
        <section className="h-screen flex flex-col justify-center relative">
          <div className="container mx-auto">
            <img className="absolute top-[10%] -left-[5%] w-[50%] md:w-[40%] max-w-[1000px]" src={AboutTopLeft} alt="Deco Left" />
            <img className="absolute top-[60%] md:top-[15%] -right-[5%] w-[50%] md:w-[40%] max-w-[1000px]" src={AboutTopRight} alt="Deco Right" />

            <div className="text-center text-white uppercase font-bold text-xl md:text-3xl mb-5">
              About...
            </div>
            <div className="bounce-animation">
              <img onClick={() => { window.location.replace("/about/#zeek-art"); }} className="mx-auto w-[300px] md:w-[400px] lg:w-[600px]" src={ZKcandyLogo} alt="ZKcandy" />

              <div className="flex justify-center mt-5">
                <div className="cursor-pointer">
                  <svg width="30" height="20" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.7 6.93333L0.7 1.6C0.205573 0.940764 0.675752 0 1.4998 0H9.50143C10.3255 0 10.7944 0.940764 10.3 1.6L6.3 6.93333C5.9 7.46667 5.1 7.46667 4.7 6.93333Z" fill="white" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="zeek-art" className="xl:min-h-screen z-10 relative">
          <div className="mx-auto w-full relative">
            <div className="left relative max-w-[1800px] w-[75%] md:w-[65%] -mb-10 md:-mb-20 lg:-mb-40">
              <img className="relative z-10 hidden md:flex w-[85%]" src={AboutArtLeft} alt="Deco Left" />
              <img className="relative z-10 md:hidden" src={AboutArtLeftMobile} alt="Deco Left" />
            </div>
            <div className="right absolute top-[0%] right-0 max-w-[1800px] w-[75%] md:w-[65%] z-10">
              <img className="ms-auto mr-0 hidden md:flex w-[85%]" src={AboutArtRight} alt="Deco Right" />
              <img className="ms-auto mr-0 md:hidden" src={AboutArtRightMobile} alt="Deco Right" />
            </div>
          </div>
        </section>
      </div>

      <section id="backed-by" className='bg-white pt-40 pb-20'>
        <div className="container mx-auto">
          <div className='uppercase text-center lg:text-[4rem] md:text-[3rem] text-[2rem] text-primary font-black'>Backed By</div>

          <p className='w-[90%] max-w-[900px] mx-auto italic lg:text-[1.125rem] md:text-[1rem] text-[.9rem] font-medium text-center md:leading-8 leading-6 mb-20'>ZKcandy is backed by iCandy Interactive, Southeast Asia’s largest game studio, with 500+ games, including 180 AAA titles, downloaded 300M+ times. We're powered by ZKsync technology, where simplified onboarding and negligible fees lay the ground for mass adoption.</p>

          <div className="grid md:grid-cols-2 grid-cols-1 items-center mb-10">
            <a href='https://zksync.io/' target='_blank' rel="noreferrer" className='btn-dotted-white md:w-[300px] w-[250px] h-[100px] md:h-[140px] lg:ms-auto lg:me-20 mx-auto md:mb-0 mb-5'>
              <div className="left-dot"></div>
              <div className="right-dot"></div>
              <img src={logoZksync} alt="logo" />
            </a>

            <div className='md:p-0 p-5 md:max-w-[500px]'>
              <h6 className='uppercase text-primary font-black mb-4 md:text-[2rem] text-[1.8rem] md:text-left text-center'>ZKSync</h6>
              <p className='italic lg:text-left text-justify font-medium md:pe-10 md:text-[1rem] text-[.9rem]'>
                ZKsync is cutting-edge zero-knowledge (ZK) technology to scale Ethereum and bring crypto to the mainstream — reaching millions of developers and billions of people needing a technological solution for achieving progress and prosperity. Deeply rooted in its mission to advance personal freedom for all, the ZKsync blockchain network makes digital self-ownership universally available. It is trustless, secure, reliable, censorship-resistant, privacy-preserving, hyperscalable, accessible, and sovereign.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 grid-cols-1 items-center pb-10">
            <a href='https://www.icandy.io/' target='_blank' rel="noreferrer" className='btn-dotted-white md:w-[300px] w-[250px] h-[100px] md:h-[140px] lg:ms-auto lg:me-20 mx-auto md:mb-0 mb-5'>
              <div className="left-dot"></div>
              <div className="right-dot"></div>
              <img className='' src={logoIcandy} alt="iCandy" />
            </a>

            <div className='md:p-0 p-5 md:max-w-[500px]'>
              <h6 className="uppercase text-primary font-black mb-4 md:text-[2rem] text-[1.8rem] md:text-left text-center">
                iCandy
              </h6>
              <p className='italic lg:text-left text-justify font-medium md:pe-10 md:text-[1rem] text-[.9rem]'>
                iCandy Interactive Limited (iCandy) stands as one of the major game development studios in Southeast Asia and Oceania. As a publicly listed company on the ASX, iCandy boasts over 650 full-time employees, operating gaming studios in Germany, Thailand, Malaysia, Singapore, and Australia. Noteworthy shareholders in iCandy encompass Animoca Brands, Singtel, SK Telecom, AIS, Baidu, and others.
              </p>
            </div>
          </div>

          <div className="uppercase font-black text-primary text-center mt-20 text-[2rem] md:text-[2.8rem]">Supported By</div>
        </div>
        <div className='marquee pt-8'>
          <ul className='marquee__content'>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyWemix} alt='Wemix' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyAnimoca} alt='Animoca Brands' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbySpartan} alt='Spartan' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPerlone} alt='Perlone Capital' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPresto} alt='Presto' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyFlowdesk} alt='Flowdesk' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyLecca} alt='Lecca' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyEfficientFrontier} alt='Efficient Frontier' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPrometheuz} alt='Prometheuz' /></li>
          </ul>
          <ul className='marquee__content' aria-hidden='true'>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyWemix} alt='Wemix' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyAnimoca} alt='Animoca Brands' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbySpartan} alt='Spartan' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPerlone} alt='Perlone Capital' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPresto} alt='Presto' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyFlowdesk} alt='Flowdesk' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyLecca} alt='Lecca' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyEfficientFrontier} alt='Efficient Frontier' /></li>
            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPrometheuz} alt='Prometheuz' /></li>
          </ul>
        </div>
      </section>

      <section id="about-unique">
        <div className="mx-auto max-w-[1800px] w-full relative">

          <img className="w-[70%] md:w-[50%] lg:w-[60%] 2xl:w-[55%] mx-auto top-0 lg:pb-5 -mb-6" src={AboutVR} alt="VR" />

          <img className="absolute left-10 top-[50%] lg:top-[0%] w-[200px]" src={AboutPlanetLeft} alt="Floating Planet" />
          <img className="absolute right-10 top-[50%] lg:top-[0%] w-[200px]" src={AboutPlanetRight} alt="Floating Planet" />

          <div className="container pt-4 px-5 mx-auto text-dark lg:text-white mt-5 lg:absolute lg:top-0 lg:-translate-x-1/2 lg:left-1/2">
            <h1 className="text-shadow-purple text-center uppercase font-black text-white text-[2rem] md:text-[2.5rem] xl:text-[3rem] leading-[1]  mb-5">
              What Make Us <br /> Unique
            </h1>
            <div className="flex flex-col md:items-center lg:items-start lg:flex-row lg:justify-between relative space-y-6 lg:space-y-0 2xl:pt-10">
              <div className="w-full md:w-[80%] lg:w-[20%] text-center lg:text-left bg-white lg:bg-transparent rounded-xl lg:rounded-none border-2 border-black p-4 lg:p-0 lg:border-none">
                <h2 className="font-bold uppercase lg:text-xl xl:text-2xl mb-2 lg:mb-5">Mobile-first Approach</h2>
                <p className="italic text-sm lg:text-xs xl:text-sm">
                  Dive into a seamless mobile Web3 gaming experience. ZKcandy combines the power of ZK-rollups with the mobile gaming expertise of iCandy to offer fast, secure, and user-friendly blockchain games.
                </p>
              </div>
              <div className="w-full md:w-[80%] lg:w-[25%] text-center bg-white lg:bg-transparent rounded-xl lg:rounded-none border-2 border-black p-4 lg:p-0 lg:border-none">
                <h2 className="font-bold uppercase lg:text-xl xl:text-2xl mb-2 lg:mb-5">AI-driven Games</h2>
                <p className="italic text-sm lg:text-xs xl:text-sm">We're pushing the boundaries of Web3 gaming with AI-powered players. Our AI agents will compete, learn, and evolve across all EVM ecosystems.</p>
              </div>
              <div className="w-full md:w-[80%] lg:w-[20%] text-center lg:text-right bg-white lg:bg-transparent rounded-xl lg:rounded-none border-2 border-black p-4 lg:p-0 lg:border-none">
                <h2 className="font-bold uppercase lg:text-xl xl:text-2xl mb-2 lg:mb-5">Powering The Next Generation of IP-driven Games</h2>
                <p className="italic text-sm lg:text-xs xl:text-sm">ZKcandy is bringing your favorite IPs to the world of Web3 gaming. With iCandy's decades of experience and relationships with global brands, we're building immersive blockchain games featuring iconic characters and stories.</p>
              </div>
            </div>
          </div>

          <img className="lg:absolute bottom-0" src={AboutPlanet} alt="ZKcandy Planet" />
          <img src={AboutCloud} alt="Clouds" className="hidden xl:flex absolute -bottom-[10%] -left-[17%] w-[40%]" />
          <img src={AboutCloud} alt="Clouds" className="hidden xl:flex absolute -bottom-[10%] -right-[17%] w-[40%] -scale-x-100" />

        </div>
      </section>
    </div>
  );
}